import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

let productId;
let viewDeleted = false;

const fetchSuites = async () => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "getTestSuites",
    companyid: user.companyid,
    productid: productId,
  });

  if (viewDeleted) {
    params.append("viewDeleted", "true");
  }

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params}`);

  return response.data;
};

const useGetTestSuitesQuery = () => {
  const query = useQuery({
    queryKey: ["GetTestSuitesTest"],
    queryFn: () => {
      return fetchSuites(productId);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (id, options = {}) => {
    productId = id;
    viewDeleted = typeof options === "boolean" ? options : !!options?.viewDeleted;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useGetTestSuitesQuery;
